import { createStore } from 'redux';
import { rootReducer } from './redux/rootreducer';

export const store = createStore(rootReducer);